@if (managedUnits > 0) {
  <mat-form-field class="me-2">
    <mat-label>User (For NPN Search)</mat-label>
    <input
      type="text"
      placeholder="Select a user..."
      matInput
      [matAutocomplete]="autoUser"
      [formControl]="userControl"
    />
    <mat-autocomplete
      #autoUser="matAutocomplete"
      [displayWith]="displayUser"
      (optionSelected)="changeSelection($event)"
    >
      @if (userDropdownLoading) {
        <mat-option disabled class="dropdownLoadingSpinner">
          <mat-spinner diameter="48" />
        </mat-option>
      }
      @if (!userDropdownLoading && userDropdownNoResults) {
        <mat-option disabled>No Results</mat-option>
      }
      @if (!userDropdownLoading && !userDropdownNoResults) {
        @for (opt of filteredUsers; track opt.value) {
          <mat-option class="custom-select-option" [value]="opt">
            {{ opt.name }}
          </mat-option>
        }
      }
    </mat-autocomplete>
  </mat-form-field>
}

<mat-form-field class="npn-filter me-2 {{ chips().length ? 'has-value' : '' }}">
  <mat-label>{{ field.label }}</mat-label>
  <mat-chip-grid
    #chipGrid
    aria-label="{{ field.label }} selection"
    [disabled]="
      managedUnits > 0 &&
      (!userControl.value || chipOptions().length <= 0 || fetchingNpns) &&
      chips().length <= 0
    "
  >
    @for (chip of chips(); track $index) {
      <mat-chip-row (removed)="remove(chip)">
        {{ chipDisplay(chip) }}
        <button matChipRemove [attr.aria-label]="'remove ' + chip">
          <mat-icon>cancel</mat-icon>
        </button>
      </mat-chip-row>
    }
  </mat-chip-grid>
  <input
    #chipInput
    placeholder="Select {{ field.label }}..."
    name="currentChip"
    [matAutocomplete]="chipAuto"
    [matChipInputFor]="chipGrid"
    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
    [matChipInputAddOnBlur]="true"
    [disabled]="
      managedUnits > 0 &&
      (!userControl.value || (userControl.value && chipOptions().length <= 0))
    "
    [(ngModel)]="currentChip"
    (blur)="onBlur($event)"
  />
  <mat-autocomplete
    #chipAuto="matAutocomplete"
    (optionSelected)="selected($event)"
  >
    @for (chip of filteredChips(); track chip) {
      <mat-option [value]="chip.NPN">
        {{ chip.Name }} - {{ chip.NPN }}
      </mat-option>
    }
  </mat-autocomplete>
  @if (!userControl.value) {
    <mat-hint>Select a user to enable</mat-hint>
  } @else if (fetchingNpns) {
    <mat-hint>Retrieving associated NPNs</mat-hint>
  } @else if (userControl.value && chipOptions().length <= 0) {
    <mat-hint>No associated NPNs found</mat-hint>
  }
  @if (field.conditionalHint) {
    <mat-hint>{{ field.conditionalHint }}</mat-hint>
  }
</mat-form-field>
